











import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop, Watch} from 'vue-property-decorator';
import DynamicDocumentLockEventConfigurationTemplate from '@/views/dynamicdocuments/fields/dynamic-document-lock-event-configuration-template.vue';

@Component({
  name: 'dynamic-document-event-configuration-template',
  components: {
    DynamicDocumentLockEventConfigurationTemplate
  }
})
export default class DynamicDocumentEventConfigurationTemplate extends Vue {

  @Prop({required: true}) value!: DisguiseDto.DynamicDocumentEventDtoUnion;
  innerValue: DisguiseDto.DynamicDocumentEventDtoUnion | null = null;

  created() {
    this.innerValue = this.value;
  }

  @Watch('value') valueChanged(newValue: DisguiseDto.DynamicDocumentLockEventDto) {
    this.innerValue = newValue;
  }

  @Watch('innerValue') innerValueChanged(newValue: DisguiseDto.DynamicDocumentLockEventDto) {
    this.$emit('input', newValue);
  }

}
